//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {AppMixin} from "~/node_modules/sitis-nuxt/lib/mixins";

export default {
  props: {
    category: Object
  },

  mixins: [
    AppMixin
  ],

  computed: {

    isShowOpravy: function () {
      const bool = this.vars?.['скрыть-подразделы-оправы'] || "";
      const boolLowerCase = bool.toLocaleLowerCase();

      return !Boolean(boolLowerCase === "да");
    }

  }
}
